<template>
  <div>
    <NuxtLayout name="split">
      <template #aside>
        <UIcon
          name="EscapadaLogoSmall"
          class="w-12 h-12 mb-6 text-white"
          aria-hidden="true"
        />

        <ul>
          <li
            v-for="(item, index) in asideTexts"
            :key="index"
            class="flex gap-x-2"
          >
            <TTitle
              size="base"
              color-classes="text-white"
              :bold="true"
              leading="tight"
              classes="m-0"
            >
              {{ item }}
            </TTitle>
          </li>
        </ul>
      </template>
      <AuthLoginNew />
      <div class="text-center text-sm">
        <a
          class="underline text-primary-600 font-bold"
          :href="routes().ownerRegistration()"
        >
          {{ $t('auth.login.label2') }}
        </a>

        <TText classes="my-3 text-sm">{{
          $t('auth.login.label-separator')
        }}</TText>

        <i18n-t keypath="auth.login.label" tag="span" scope="global">
          <template #register>
            <a
              class="underline text-primary-600 font-bold text-base"
              :href="routes().travelerRegistration()"
            >
              {{ $t('auth.login.register') }}
            </a>
          </template>
        </i18n-t>
      </div>
      <SSpacer />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import { useMenuBreadcrumbStore } from '~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadInfoComposable } from '~/modules/head/composables/useHeadInfoComposable'

const { t } = useI18n({})
const { setHeadInfo } = useHeadInfoComposable()
const breadCrumbMenuStore = useMenuBreadcrumbStore()

breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.login'))

definePageMeta({
  layout: false,
  splitImageUrl: '/__nuxt-public/images/registration/split-side.jpeg',
  splitImageAlt: 'views.login.pageMeta.splitImageAlt',
})

setHeadInfo({
  title: t('views.login.seo.title'),
  description: t('views.login.seo.description'),
  robotsVisible: true,
  images: [
    {
      url: '/__nuxt-public/images/registration/split-side.jpeg',
      alt: t('views.login.seo.title'),
    },
  ],
})

const asideTexts: Array<string> = [
  t('views.login.aside.text1'),
  t('views.login.aside.text2'),
  t('views.login.aside.text3'),
  t('views.login.aside.text4'),
]

onMounted(() => {
  const { isAndroid, isIos } = useDevice()
  isIos && window.webkit?.messageHandlers?.goToLogin?.postMessage('')
  isAndroid && window?.ERAndroid?.goToLogin()
})
</script>
